<div class="login-container">
  <div class="login-card">
    <!-- Logo y título -->
    <div class="logo-container">
      <img src="assets/img/logo.png" alt="Logo">
    </div>

    <!-- Formulario -->
    <form #f="ngForm" (ngSubmit)="doAction(f)" ngNativeValidate>
      <!-- Campo de usuario -->
      <div class="form-group">
        <label for="username">Usuario</label>
        <div class="input-group">
          <input [(ngModel)]="item.usuario" name="usuario" required class="form-control">
          <i class="icon fas fa-user"></i>
        </div>
      </div>

      <!-- Campo de email -->
      <div class="form-group">
        <label for="password">Email</label>
        <div class="input-group">
          <input type="mail" [(ngModel)]="item.correo" name="correo" required class="form-control">
          <i class="icon fas fa-box"></i>
        </div>
      </div>

      <div class="form-group">
        <label for="username">Apellido y Nombre</label>
        <div class="input-group">
          <input [(ngModel)]="item.nombre" name="nombre" required class="form-control">
          <i class="icon fas fa-people-carry"></i>
        </div>
      </div>


      <!-- Botón de login -->
      <button [disabled]="proccess" [class.disabled]="proccess" type="submit" class="btn-login">
        <ng-container *ngIf="proccess; else elseTemplate">
          Espere por favor ...
        </ng-container>
        <ng-template #elseTemplate>
          Registrarse
        </ng-template>

      </button>
    </form>
  </div>
</div>